import { useState, useEffect, useRef } from 'react';

export const useStickyBarWithOffset = (
  frame_height = 86
): [React.RefObject<HTMLDivElement | null>, boolean] => {
  const ref = useRef<HTMLDivElement>(null);
  const [stickBarFixed, setStickyBarFixed] = useState(false);

  const onScroll = (): void => {
    const top = ref?.current?.getBoundingClientRect().top;

    if (top && top <= frame_height) {
      setStickyBarFixed(true);
    }

    if (top && top > frame_height) {
      setStickyBarFixed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return [ref, stickBarFixed];
};
